module.exports = __webpack_public_path__ + "images/fourteen-year-club-f2cd6b9d26bf519d36196ad52c4b8f4f.png";